const modalData = {
  title: 'Únete a la comunidad',
  subtitle: 'Más de 200k creativos están aprendiendo con nosotros',
  benefits: [
    'Acceso ilimitado a las clases',
    'Atención exclusiva para miembros premium',
    'Certificación oficial al terminar los cursos',
  ],
};

export default modalData;
